import React, { useState } from 'react';
import { signOutUser } from '../../utils/adminAuth';

export function AdminHeader({ title, actions = null }) {
  const [error, setError] = useState('');

  const handleSignOut = async () => {
    setError('');
    try {
      await signOutUser();
    } catch {
      setError('Nem sikerült kijelentkezni.');
    }
  };

  return (
    <div className="mb-6 space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="font-display text-3xl md:text-4xl font-bold">{title}</h1>
          <button type="button" onClick={handleSignOut} className="btn-secondary text-sm whitespace-nowrap">
            Kijelentkezés
          </button>
        </div>
        {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
      </div>
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
